module.exports = __webpack_public_path__ + "img/hk_shako2.918b8a1f.png";